// import firebase from "@/generic_api/firebase/firebase";
import firebase from "@firebase/app";
import { FirebaseError } from '@firebase/util'
import $models from '@/models'
import moment from '@/moment-gp'

const $invitation = $models.invitation;
let userLoaded = false;

// ----------------------------------------------------------------------------
export async function auth_signup({ userEmail, userPassword, userName }) {
  return firebase
    .auth()
    .createUserWithEmailAndPassword(userEmail, userPassword)
    .then(() => {
      auth_update_display_name({ displayName: userName })
    })
    /* .catch(error => {
      let errorCode = error.code;
      let errorMessage = error.message;
      console.log("[auth] signUpError1", errorCode, errorMessage);
      return error;
    }); */
}

// ----------------------------------------------------------------------------
export async function auth_current_user() {
  return new Promise((resolve, reject) => {
     if (userLoaded) {
        resolve( firebase.auth().currentUser );
     }
     const unsubscribe = firebase.auth().onAuthStateChanged(user => {
        userLoaded = true;
        unsubscribe();
        resolve(user);
     }, reject);
  });
}

// ----------------------------------------------------------------------------
/* Return true if user is logged in, false if user is not logged in and 'null'
   if user authentication is still in progress */
export function auth_user_is_logged_in() {
  return userLoaded ? !!firebase.auth().currentUser : null
}

// ----------------------------------------------------------------------------
export function auth_activate_user() {

  let currentUserId = firebase.auth().currentUser.uid;

  return $models.userSettings.update(currentUserId, {
    clientActivationRequest: moment.currentTimeServer('REALTIMEDB')
  })
}

// ----------------------------------------------------------------------------
export async function auth_activate_invitation({ email, invitationCode }) {

  if ( !email ) { // TODO: Check email address
    throw new Error('Invalid email', email)
  }

  if ( !/^\d{6}$/.test( invitationCode ) ) { // move to function auth_validate_invitation_code()?
    throw new Error('Invalid invitationCode', invitationCode)
  }

  let email_base64 = btoa( email );

  let pInvitation = $invitation
    .with({ email: email_base64 })
    .update(invitationCode, {
      clientActivationRequest: moment.currentTimeServer('REALTIMEDB')
  })

  // write `/invitation/${email_base64}/{inv_code}/activate` += 1

  return pInvitation
}

// ----------------------------------------------------------------------------
export async function auth_check_invitation_code({ code = null, email = null }) {

  console.log("[api:auth] auth_check_invitation_code", code, email)

  // TODO: maybe email can also be user input ?

  // save invite code to vuex for later use

  // user is signed in
  if ( firebase.auth().currentUser ) {

    let email_from_auth = firebase.auth().currentUser.email

    if ( email !== email_from_auth ) {
      // This happens when I'm logged in as user A, but klick on an invitation from user B
      console.warn("Invitation email and currents user email don't macht")
      throw new Error('wrong-account')
    }

    try {
      await auth_activate_invitation({ email: email_from_auth, invitationCode: code })
      return true
    } catch ( error ) {

      // 1. Check if permission denied error
      if ( error instanceof FirebaseError &&
          ( error.code === 'permission_denied' ||
            error.code === 'PERMISSION_DENIED' ) ) {
        console.log('Firebase PERMISSION ERROR 1')
        throw new Error('wrong-code')
      }

      // 2. In production we have to check for error.code to, since 1 won't work
      if ( error.code === 'PERMISSION_DENIED' ) {
        console.log('Firebase PERMISSION ERROR 2')
        throw new Error('wrong-code')
      }

      console.warn("[auth:auth_check_invitation_code] error", error)
      console.warn("[auth:auth_check_invitation_code] error.message", error.message)
      console.warn("[auth:auth_check_invitation_code] error.code", error.code)
      throw error;
    }
  }

  throw new Error('not-logged-in')
}

// ----------------------------------------------------------------------------
export async function auth_login_with_provider({ providerName, rememberMe }) {
  console.log("[auth] login_with_provider", providerName);

  // if user is already logged in return
  if ( firebase.auth().currentUser ) {
    return
  }

  let provider = null;
  switch (providerName) {
    case "google":
      provider = new firebase.auth.GoogleAuthProvider();
      break;
    case "twitter":
      provider = new firebase.auth.TwitterAuthProvider();
      break;
    case "facebook":
      provider = new firebase.auth.FacebookAuthProvider();
      break;
    case "github":
      provider = new firebase.auth.GithubAuthProvider();
      break;
    case "oauth":
      provider = new firebase.auth.OAuthProvider();  /* TODO */
      break;
  }

  /*
  function handleError(error) {
    var errorCode = error.code;
    var errorMessage = error.message;
    console.warn("Login Error:", errorCode, errorMessage);
    return error;
  }
  */

  let persistenceSetting = rememberMe
    ? firebase.auth.Auth.Persistence.LOCAL
    : firebase.auth.Auth.Persistence.SESSION

  // TODO: No nested promises
  return firebase
    .auth()
    .setPersistence(persistenceSetting)
    .then(() => {
      // Existing and future Auth states are now persisted in the current
      // session only. Closing the window would clear any existing state even
      // if a user forgets to sign out.
      // ...

      // New sign-in will be persisted with session persistence.
      // let result = firebase.auth().signInWithPopup(provider);
      let result = firebase.auth().signInWithRedirect(provider);
      // firebase.auth().getRedirectResult().then((result) => {
      //   if (result.credential) {
      //     // This gives you a Google Access Token. You can use it to access the Google API.
      //     // var token = result.credential.accessToken;
      //     // ...
      //   }
      //   // The signed-in user info.

      //   // On first login = sign up, call: ?
      //    // auth_update_display_name({ displayName: userName }) ??

      //   //var user = result.user;
      //   return result
      // }).catch(handleError);
      console.log("[auth] succesfully logged in", result);
    })
    .catch(error => {
      // Handle Errors here.
      console.log("[auth] error while logging in", error);
    });
}

// ----------------------------------------------------------------------------
export async function auth_login_with_email_and_password({
  userEmail,
  userPassword,
  rememberMe
}) {

  if ( firebase.auth().currentUser ) {
    return
  }

  function handleError(error) {
    var errorCode = error.code;
    var errorMessage = error.message;
    console.warn("Login Error:", errorCode, errorMessage);
    return error;
  }

  // TODO: Refactor
  var result = '';
  try {
    if (!rememberMe) {
      result = firebase.auth().currentUser;
      if (result !== null) {
        return result;
      }

      let persistenceSetting = rememberMe
        ? firebase.auth.Auth.Persistence.LOCAL
        : firebase.auth.Auth.Persistence.SESSION

      return await firebase
        .auth()
        .setPersistence(persistenceSetting)
        .then(() => {
          return firebase
            .auth()
            .signInWithEmailAndPassword(userEmail, userPassword)
            .catch(handleError);
        })
        .catch(handleError);
    } else {
      // result = firebase.getInstance().getCurrentUser()
      // .catch(handleError);
      result = firebase.auth().currentUser;
      if (result === null) {

        result = await firebase
          .auth()
          .signInWithEmailAndPassword(userEmail, userPassword)
          .catch(handleError);
      }
      return result;
    }
  } catch (error) {
    console.log("[auth] Exception not handles during login", error);
  }
}

// ----------------------------------------------------------------------------
export async function auth_logout() {
  //context.dispatch("user_updateOnlineStatus", { isOnline: 'offline' });
  try {
    await firebase.auth().signOut();
  } catch (error) {
    console.log("[auth] error", error);
  }
}

// ----------------------------------------------------------------------------
export function auth_forgot_password({ userEmail }) {
  // TODO: validate input
  if ( !userEmail ) {
    throw new Error('Invalid input', userEmail);
  }
  return firebase.auth().sendPasswordResetEmail( userEmail );
}

// ----------------------------------------------------------------------------
export function auth_update_password({ userPassword }) {
  /* Returns promise */
  let user = firebase.auth().currentUser;
  return user.updatePassword(userPassword);
}

// ----------------------------------------------------------------------------
// Currently not used
export async function auth_check_if_user_exists({ userEmail }) {
  let results = await firebase.auth().fetchSignInMethodsForEmail(userEmail);
  return results[0] !== undefined;
}

// -----------------------------------------------------------------------------
export async function auth_update_display_name({ displayName }) {
  return firebase.auth().currentUser.updateProfile({
    displayName: displayName,
  })
}

// -----------------------------------------------------------------------------
export async function auth_request_invitation_code({ email }) {
  return Promise.reject(new Error('NOT_IMPLEMENTED'))
}
